// extracted by mini-css-extract-plugin
export default {"carouselGalleryContainer":"CarouselGallery_carouselGalleryContainer__a8Xqd","item":"CarouselGallery_item__uIlEc","awssld__bullets":"CarouselGallery_awssld__bullets__72qP4"};